export default {
	name: "SkeletonTile",
	props: {
	},
	setup() {
	},
};